import {QueryClient} from "react-query";

export const FOLIO_DIGITAL_SIGNINGS_KEY = ['digitalSignings', 'folio'];
export const digitalSigningFolioKey = (folioId?: string) => [...FOLIO_DIGITAL_SIGNINGS_KEY, folioId];
export const digitalSigningDetailsKey = (id?: string) => ['digitalSignings', 'details', id];

export const DIGITAL_SIGNING_PREFILL_KEY = ['digitalSignings', 'prefill'];
export const digitalSigningPrefillKey = (folioId?: string, reservationId?: string) => [...DIGITAL_SIGNING_PREFILL_KEY, folioId, reservationId];
export const DIGITAL_SIGNING_OFFERED_KEY = ['digitalSigningTemplates', 'offered'];
export const DIGITAL_SIGNING_STALE_TIME = 30 * 1000;

export const invalidateDigitalSigningTemplateChoices = (queryClient: QueryClient) => Promise.all([
    queryClient.invalidateQueries(DIGITAL_SIGNING_OFFERED_KEY),
    queryClient.invalidateQueries(DIGITAL_SIGNING_PREFILL_KEY),
]);
